import type { PickerOption } from '../store/schema/CompositePickerInterfaces';
import type CompositePickerStore from '../store/schema/CompositePickerStore';

/**
 * Get the picker option for a specific index
 * @param index
 */
export default function getPickerOptionForIndex(
    viewState: CompositePickerStore,
    index: number
): PickerOption | null {
    const { filteredOptions } = viewState;

    for (let option of filteredOptions) {
        if (option?.leafOptions) {
            const calendar = option.leafOptions.filter(cal => cal && cal.index === index);

            if (calendar.length > 0) {
                return calendar[0];
            }
        }

        if (option?.parentOptions) {
            for (let parent of option.parentOptions) {
                if (parent && parent.index === index) {
                    return parent;
                }

                if (parent?.children) {
                    const child = parent.children.filter(child => child && child.index === index);

                    if (child.length > 0) {
                        return child[0];
                    }
                }
            }
        }
    }

    return null;
}
